import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexEdge',
  setup(__props) {

const edgesButtons = defineAsyncComponent(() => import("@/components/theme/buttons/edge/edgesButtons.vue"))
const edgesButtons2 = defineAsyncComponent(() => import("@/components/theme/buttons/edge/edgesButtons2.vue"))


return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Buttons",
      title: "Edge Buttons"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(edgesButtons)),
          _createVNode(_unref(edgesButtons2))
        ])
      ])
    ])
  ], 64))
}
}

})